import React, { useState, useEffect } from 'react'
import axios from 'axios'
import { Navbar,Nav,NavDropdown,Container,ListGroup } from 'react-bootstrap';
// import Logo_ from '../images/Logo_.png'
const Navigationbar = () => {
    
    const [departments,setDepartments] = useState([ { id:'', name: '', description: '', createdAt: '', updatedAt: ''} ])
    const [hospitals,setHospitals] = useState([ { id:'', name: '', description: '', createdAt: '', updatedAt: ''} ])

    useEffect(() => {
        axios.get(process.env.REACT_APP_API_URL+'/departments').then(response=>setDepartments(response.data.data)).catch(error=>console.log(error))
        axios.get(process.env.REACT_APP_API_URL+'/hospitals').then(response=>setHospitals(response.data.data)).catch(error=>console.log(error))
    }, [])

    return (
        <div>
            <Navbar collapseOnSelect expand="lg" bg="light" fixed="top" style={{boxShadow: "0 2px 4px 0 rgba(0,0,0,.2)"}}>
                <Container>
                    <Navbar.Brand href="/">
                        <img
                            src="/Logo_.png"
                            alt="NIPRM"
                            style={{ width:'280px', height:'60px' }}
                        />
                    </Navbar.Brand>
                    <Navbar.Toggle aria-controls="responsive-navbar-nav" />
                    <Navbar.Collapse id="responsive-navbar-nav">
                        <Nav className="me-auto">
                            {/* <Nav.Link href="#features">Features</Nav.Link>
                            <Nav.Link href="#pricing">Pricing</Nav.Link> */}
                            
                        </Nav>
                        <Nav>
                            <Nav.Link href="/">HOME</Nav.Link>
                            
                            <NavDropdown title="ADMISSIONS" id="collasible-nav-dropdown">
                                <NavDropdown.Item href="/admissions/howtoapply">How To Apply</NavDropdown.Item>
                                <NavDropdown.Item href="/admissions/datesdeadlines">Dates And Deadlines</NavDropdown.Item>
                                <NavDropdown.Item href="/admissions/feestructure">Fee Structure</NavDropdown.Item>
                                <NavDropdown.Item href="/admissions/rules">Admission Rules</NavDropdown.Item>
                            </NavDropdown>

                            {/* <Nav.Link href="#deets">OFFERED PROGRAMS</Nav.Link> */}
                            
                            <NavDropdown title="ACADEMICS">
                                <div style={{display:'flex'}}>
                                    <ListGroup>
                                        <h5 className="mb-0" style={{paddingLeft:'5px',paddingBottom:'5px'}}>Overview</h5>
                                        <hr style={{height:'5px',width:'10%',color:'black',margin:'0px 5px',borderRadius: '21px'}}></hr>
                                        <NavDropdown.Item href="/academics/exampolicy">Examination Policy</NavDropdown.Item>
                                        <NavDropdown.Item href="/academics/disciplinepolicy">Disciplinary Policy</NavDropdown.Item>
                                        <NavDropdown.Item href="/academics/degreeprograms">Degree Programmes</NavDropdown.Item>    
                                    </ListGroup>
                                    <ListGroup>
                                        <h5 className="mb-0" style={{paddingLeft:'5px',paddingBottom:'5px'}}>Students</h5>
                                        <hr style={{height:'5px',width:'10%',color:'black',margin:'0px 5px',borderRadius: '21px'}}></hr>
                                        <NavDropdown.Item href="/academics/timetable">Time Table</NavDropdown.Item>
                                        <NavDropdown.Item href="/academics/examsschedule">Examination Schedule</NavDropdown.Item>
                                        <NavDropdown.Item href="/academics/examsresults">Examination Results</NavDropdown.Item>
                                    </ListGroup>    
                                </div>
                            </NavDropdown>

                            <NavDropdown title="DEPARTMENTS" id="collasible-nav-dropdown">
                                {
                                    departments.map((department,index)=>{
                                        return(
                                            <NavDropdown.Item key={index} href={`/departments/${department.name}`}>{department.name}</NavDropdown.Item>
                                            
                                        )
                                    })
                                }
                            </NavDropdown>
                            
                            <Nav.Link href="/faculty">FACULTY</Nav.Link>
                            
                            {/* make hospitals dropdown */}
                            {/* <Nav.Link href="/hospitals">HOSPITALS</Nav.Link> */}
                            <NavDropdown title="HOSPITALS" id="collasible-nav-dropdown">
                                {
                                    hospitals.map((hospital,index)=>{
                                        return(
                                            <NavDropdown.Item key={index} href={`/hospitals/${hospital.name}`}>{hospital.name}</NavDropdown.Item>
                                        )
                                    })
                                }
                            </NavDropdown>
                            

                            <Nav.Link href="/newsandevents">NEWS & EVENTS</Nav.Link>
                            <Nav.Link href="/facilities">FACILITIES</Nav.Link>
                            <Nav.Link href="/careers">CAREERS</Nav.Link>

                        </Nav>
                    </Navbar.Collapse>
                </Container>
            </Navbar>
        </div>
    )
}

export default Navigationbar